import { events } from '@sparrow-vue/sparrow-utils';
export default new events();


// WEBPACK FOOTER //
// ./src/utils/Event.js